import { moduleSelfDiagnosisStatus } from '@/domain/enums/moduleSelfDiagnosisStatus';

export default {
  props: {
    assetModule: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    shouldShowSelfDiagnosis() {
      const { WITH_SELF_DIAGNOSES_ACTIVATED } = moduleSelfDiagnosisStatus;

      return this.assetModule.moduleSelfDiagnosisStatus === WITH_SELF_DIAGNOSES_ACTIVATED;
    },
  },
};
